// this is an autogenerated file from App/Account/Content/Settings/Content/ConnectApps/App/Content/Connections/Content/ActionsColumn/mutation-apps-connection-resource-disable.graphql
import { gql } from 'Data/Api'

export default gql`
mutation app__App_Account_Content_Settings_Content_ConnectApps_App_Content_Connections_Content_ActionsColumn($id: uuid!) {
  apps_connection_resource_disable(id: $id) {
    ok
  }
}

`